const headerBurgerMenu = (config) => {
  const extendDefaults = window.themeCore.utils.extendDefaults;
  const overlay = window.themeCore.utils.overlay;
  const on = window.themeCore.utils.on;
  const removeTrapFocus = window.themeCore.utils.removeTrapFocus;
  const trapFocus = window.themeCore.utils.trapFocus;
  const focusable = window.themeCore.utils.focusable;
  const isElement = window.themeCore.utils.isElement;
  const cssClasses = window.themeCore.utils.cssClasses;
  const defaults = {
    containerId: "",
    overlayPlacement: document.body
  };
  const settings = extendDefaults(defaults, config);
  const selectors2 = {
    drawer: ".js-multi-drawer",
    drawerToggle: ".js-multi-drawer-toggle",
    drawerContent: ".js-multi-drawer-content",
    drawerTogglePrimary: "data-multi-drawer-toggle"
  };
  const mediaQuery = "(min-width: 1200px)";
  const mediaQueryList = window.matchMedia(mediaQuery);
  let container;
  let drawers;
  let drawerToggles;
  let drawerTogglesPrimary;
  let drawerContents;
  let drawerOverlay;
  let primarySelectedToggle;
  let intervalId;
  let isProcessing = false;
  async function init() {
    container = document.getElementById(settings.containerId);
    if (!container) {
      return null;
    }
    drawers = [...container.querySelectorAll(selectors2.drawer)];
    if (!drawers.length) {
      return null;
    }
    drawers = drawers.sort((a, b) => {
      const levelA = parseInt(a.getAttribute("data-drawer-level"));
      const levelB = parseInt(b.getAttribute("data-drawer-level"));
      return levelA - levelB;
    });
    drawerTogglesPrimary = [...document.querySelectorAll(`[${selectors2.drawerTogglePrimary}="${settings.containerId}"]`)];
    drawerToggles = [...container.querySelectorAll(selectors2.drawerToggle), ...drawerTogglesPrimary];
    drawerContents = [...container.querySelectorAll(selectors2.drawerContent)];
    initOverlay();
    setEventListeners();
    setEventBusListeners();
  }
  function setEventListeners() {
    drawerToggles.forEach((drawerToggle) => {
      on("click", drawerToggle, async (event) => {
        event.preventDefault();
        await processToggleDrawer(drawerToggle);
      });
    });
    on("keydown", (event) => onEscEvent(event));
    on("change", mediaQueryList, async (event) => {
      if (!event.matches) {
        await processHideDrawers(1);
      }
    });
  }
  function onEscEvent(event) {
    if (!isKeyPressIsEsc(event)) {
      return;
    }
    window.themeCore.EventBus.emit(`EscEvent:on:${settings.containerId}`);
  }
  function isKeyPressIsEsc(event) {
    return event.keyCode === 27;
  }
  function setEventBusListeners() {
    window.themeCore.EventBus.listen(`Overlay:${settings.containerId}:close`, async () => {
      if (isProcessing) {
        intervalId = setInterval(async () => {
          if (!isProcessing) {
            clearInterval(intervalId);
            await hideDrawers(1);
          }
        }, 100);
      } else {
        await hideDrawers(1);
      }
    });
    window.themeCore.EventBus.listen(`EscEvent:on:${settings.containerId}`, async () => {
      let activeDrawers = getActiveDrawers();
      if (!activeDrawers.length) {
        return null;
      }
      let drawerLevel = parseInt(activeDrawers.reverse()[0].dataset.drawerLevel);
      await processHideDrawers(drawerLevel);
    });
  }
  function initOverlay() {
    drawerOverlay = overlay({
      namespace: settings.containerId,
      overlayPlacement: settings.overlayPlacement
    });
  }
  async function processToggleDrawer(drawerToggle) {
    if (isProcessing) {
      return null;
    }
    isProcessing = true;
    await toggleDrawer(drawerToggle);
    isProcessing = false;
  }
  async function processHideDrawers(level) {
    if (isProcessing) {
      return null;
    }
    isProcessing = true;
    await hideDrawers(level);
    isProcessing = false;
  }
  async function toggleDrawer(drawerToggle) {
    let drawerLevel = parseInt(drawerToggle.dataset.drawerLevel);
    if (isActive(drawerToggle)) {
      await hideDrawers(drawerLevel);
      removeActiveToggles(drawerLevel);
    } else {
      await showDrawer(drawerLevel, drawerToggle);
    }
  }
  function removeActiveToggles(level) {
    let activeToggles = getActiveToggleByLevel(level);
    activeToggles.forEach((activeToggle) => {
      activeToggle.classList.remove(cssClasses.active);
      activeToggle.setAttribute("aria-expanded", false);
    });
  }
  function setActiveToggle(drawerToggle) {
    let drawerLevel = parseInt(drawerToggle.dataset.drawerLevel);
    removeActiveToggles(drawerLevel);
    if (drawerLevel === 1) {
      primarySelectedToggle = drawerToggle;
      let toggles = getToggleByLevel(drawerLevel);
      toggles.forEach((toggle) => {
        toggle.classList.add(cssClasses.active);
        toggle.setAttribute("aria-expanded", true);
      });
    } else {
      drawerToggle.classList.add(cssClasses.active);
      drawerToggle.setAttribute("aria-expanded", true);
    }
  }
  function isActive(target) {
    return target.classList.contains(cssClasses.active);
  }
  async function hideDrawers(level) {
    let activeDrawers = getActiveDrawers();
    let drawersToClose = activeDrawers.filter((drawer) => {
      return parseInt(drawer.dataset.drawerLevel) >= level;
    }).reverse();
    if (!drawersToClose.length) {
      return null;
    }
    for (let i = 0; i <= drawersToClose.length - 1; i++) {
      await hideDrawer(parseInt(drawersToClose[i].dataset.drawerLevel));
    }
  }
  async function showDrawer(level, drawerToggle) {
    var _a;
    await hideDrawers(level + 1);
    let drawer = getDrawerByLevel(level);
    let drawerContent = (_a = drawerToggle.dataset) == null ? void 0 : _a.drawerContent;
    setActiveToggle(drawerToggle);
    drawerContent && showList(level, drawerContent);
    let isDrawerActive = drawer.classList.contains(cssClasses.active);
    drawer.classList.add(cssClasses.active);
    if (level === 1) {
      drawerOverlay.open();
      document.body.style.overflow = "hidden";
    }
    if (isDrawerActive) {
      focusTarget(drawer);
    } else {
      await new Promise((resolve) => {
        setTimeout(() => {
          focusTarget(drawer);
          resolve();
        }, 700);
      });
    }
  }
  async function hideDrawer(level) {
    const drawer = getDrawerByLevel(level);
    const toggle = getActiveToggleByLevel(level)[0];
    drawer.classList.remove(cssClasses.active);
    removeActiveToggles(level);
    await new Promise((resolve) => {
      setTimeout(() => {
        if (level === 1) {
          drawerOverlay.close();
          document.body.style.overflow = null;
          removeFocusTarget();
        } else {
          const drawer2 = getDrawerByLevel(level - 1);
          focusTarget(drawer2, toggle);
        }
        resolve();
      }, 400);
    });
  }
  function showList(drawerLevel, listId) {
    let activeList = getActiveListByLevel(drawerLevel);
    if (activeList) {
      activeList.classList.remove(cssClasses.active);
    }
    let drawerContent = drawerContents.find((drawerContent2) => drawerContent2.dataset.drawerContent === listId);
    drawerContent.classList.add(cssClasses.active);
  }
  function getActiveDrawers() {
    return drawers.filter((drawer) => {
      return drawer.classList.contains(cssClasses.active);
    });
  }
  function getActiveToggleByLevel(level) {
    return drawerToggles.filter((drawerToggle) => {
      return parseInt(drawerToggle.dataset.drawerLevel) === level && drawerToggle.classList.contains(cssClasses.active);
    });
  }
  function getToggleByLevel(level) {
    return drawerToggles.filter((drawerToggle) => {
      return parseInt(drawerToggle.dataset.drawerLevel) === level;
    });
  }
  function getActiveListByLevel(level) {
    return drawerContents.find((drawerContent) => {
      return parseInt(drawerContent.dataset.drawerLevel) === level && drawerContent.classList.contains(cssClasses.active);
    });
  }
  function getDrawerByLevel(level) {
    return drawers.find((drawer) => {
      return parseInt(drawer.dataset.drawerLevel) === level;
    });
  }
  function focusTarget(target, elementToFocus) {
    if (!target) {
      return;
    }
    elementToFocus = elementToFocus || focusable(target, settings)[0];
    trapFocus(target, { elementToFocus });
  }
  function removeFocusTarget() {
    if (isElement(primarySelectedToggle)) {
      window.setTimeout(() => primarySelectedToggle.focus(), 0);
    }
    removeTrapFocus();
  }
  return Object.freeze({
    init
  });
};
const selectors = {
  announcementBar: ".js-announcement-bar",
  header: ".header-section",
  headerInner: ".js-header",
  headerDrawerToggler: ".js-header-drawer-toggler",
  drawerMenu: "#headerDrawerMenu",
  mainMenuToggler: ".js-main-menu-toggler",
  headerMenu: ".js-mobile-header-menu",
  headerMainMenu: ".js-mobile-header-main-menu",
  headerMenuToggler: ".js-mobile-header-menu-toggler",
  headerDesktopMenu: ".js-header-menu",
  headerDesktopMenuContainer: ".js-header-menu-container",
  headerDesktopMenuScrollContainer: ".js-header-menu-scroll-container",
  headerDesktopMenuToggler: ".js-header-menu-toggler",
  headerCartItemCount: ".js-header-cart-item-count",
  headerCartItemCountWrapper: ".js-header-cart-item-count-wrapper",
  predictiveSearchInput: ".js-predictive-search-input",
  headerContent: "[data-open-menu-type]",
  headerDropdownMenuElement: ".js-header-dropdown-menu-element",
  localizationForm: ".js-localization-form",
  localizationInput: "input[name='language_code'], input[name='country_code']",
  localizationButton: ".js-disclosure__button",
  localizationPanel: ".js-disclosure-list",
  localizationLink: ".js-disclosure__link",
  globalOverlay: "[data-js-overlay]"
};
const attributes = {
  drawerToggle: "data-js-toggle",
  itemCount: "data-cart-count",
  hideOnScrollDown: "data-hide-on-scroll-down",
  headerTransparent: "data-header-transparent",
  staticHeader: "data-static-header",
  ariaExpanded: "aria-expanded",
  hidden: "hidden",
  tabIndex: "tabindex"
};
const cssVariables = {
  headerHeight: "--header-height",
  headerHeightStatic: "--header-height-static",
  headerOffsetBottom: "--header-offset-bottom",
  headerOffsetTop: "--header-offset-top",
  headerOffsetTopStatic: "--header-offset-top-static",
  pageHeight: "--page-height",
  announcementBarHeight: "--announcement-bar-height"
};
const Header = () => {
  const Toggle = window.themeCore.utils.Toggle;
  const cssClasses = {
    ...window.themeCore.utils.cssClasses,
    forceTransition: "force-transition",
    forceChangeTransition: "force-change-transition",
    megaMenuActive: "mega-menu-active"
  };
  const isElement = window.themeCore.utils.isElement;
  const on = window.themeCore.utils.on;
  const focusable = window.themeCore.utils.focusable;
  const removeTrapFocus = window.themeCore.utils.removeTrapFocus;
  const trapFocus = window.themeCore.utils.trapFocus;
  const bind = window.themeCore.utils.bind;
  const debounce = window.themeCore.utils.debounce;
  const binder = bind(document.documentElement, {
    className: "esc-bind"
  });
  let cssRoot, announcementBar, header, headerInner, headerCartItemCount, headerContent, openMenuType, headerCartItemCountWrapper, headerDrawerTogglers, drawerMenu, mainMenuToggler, headerMenuTogglers, previouslySelectedElement, headerMenuList, headerMainMenu, headerHeight, headerHeightStatic, hideOnScrollDown, headerTransparent, staticHeader, lastScrollPosition, isHeaderHidden, openProcessing, headerDesktopMenus, headerDesktopMenuTogglers;
  const mediaQuery = "(min-width: 1200px)";
  const mediaQueryList = window.matchMedia(mediaQuery);
  let timeouts = /* @__PURE__ */ new Map();
  let activeMegaMenuHeight = 0;
  let forceToggleMegaMenu = false;
  let forceCloseDropdownMenu = false;
  let forceCloseDropdownMenuNested = false;
  let removeMegaMenuBodyScroll = false;
  const hoverOpenDelay = 140;
  const hoverCloseDelay = 240;
  const hoverMegaMenuTransitionDuration = 360;
  let clientX, clientY;
  function init() {
    cssRoot = document.querySelector(":root");
    header = document.querySelector(selectors.header);
    headerInner = document.querySelector(selectors.headerInner);
    announcementBar = document.querySelector(selectors.announcementBar);
    if (!header) {
      return;
    }
    lastScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    headerCartItemCount = header.querySelector(selectors.headerCartItemCount);
    headerContent = header.querySelector(selectors.headerContent);
    hideOnScrollDown = headerContent.hasAttribute(attributes.hideOnScrollDown);
    headerTransparent = headerContent.hasAttribute(attributes.headerTransparent);
    staticHeader = headerContent.hasAttribute(attributes.staticHeader);
    openMenuType = headerContent.dataset.openMenuType;
    headerCartItemCountWrapper = header.querySelector(selectors.headerCartItemCountWrapper);
    headerDrawerTogglers = [...header.querySelectorAll(selectors.headerDrawerToggler)];
    drawerMenu = header.querySelector(selectors.drawerMenu);
    mainMenuToggler = header.querySelector(selectors.mainMenuToggler);
    headerMainMenu = header.querySelector(selectors.headerMainMenu);
    headerMenuTogglers = [...header.querySelectorAll(selectors.headerMenuToggler)];
    headerMenuList = [];
    if (drawerMenu) {
      headerMenuList = [...drawerMenu.querySelectorAll(selectors.headerMenu)];
    }
    headerDesktopMenus = [...header.querySelectorAll(selectors.headerDesktopMenu)];
    headerDesktopMenuTogglers = [...header.querySelectorAll(selectors.headerDesktopMenuToggler)];
    previouslySelectedElement = {};
    headerHeight = getHeaderHeight();
    headerHeightStatic = headerHeight;
    openProcessing = false;
    initDrawers();
    initBurgerMenu();
    setEventListeners();
    setEventBusListeners();
    headerTopPositionHandler();
  }
  function setEventListeners() {
    on("scroll", updateHeaderVariables);
    on("resize", updateHeaderVariables);
    if (announcementBar) {
      const announcementBarObserver = new ResizeObserver(() => {
        updateHeaderVariables();
        if (headerTransparent) {
          headerTopPositionHandler();
        }
      });
      announcementBarObserver.observe(announcementBar);
    }
    if (headerTransparent) {
      on("scroll", debounce(() => setTimeout(headerTopPositionHandler, 0), 0, false));
      on("resize", () => headerTopPositionHandler());
    }
    on("change", mediaQueryList, (event) => {
      if (event.matches) {
        if (isTargetActive(drawerMenu)) {
          closeLocalizationSelector();
          window.themeCore.EventBus.emit("Toggle:headerToggleMenuDrawer:close");
        }
      } else {
        closeLocalizationSelector();
        closeActiveDesktopMenus();
      }
    });
    if (headerDesktopMenuTogglers) {
      if (openMenuType === "hover") {
        on("mousemove", document, (event) => {
          clientX = event.clientX;
          clientY = event.clientY;
        });
      }
      headerDesktopMenuTogglers.forEach((toggler) => {
        const menu = headerDesktopMenus.find((desktopMenu) => desktopMenu.id === toggler.dataset.target);
        if (!menu) {
          return;
        }
        switch (openMenuType) {
          case "click":
            toggler.addEventListener("click", () => desktopMenuClickHandler(toggler, menu));
            break;
          case "hover":
            toggler.addEventListener("mouseenter", (_) => desktopMenuMouseEnterHandler(toggler, menu));
            toggler.addEventListener("click", () => {
              if (toggler.matches(":not(:focus-visible)")) {
                navigateToLink(toggler.dataset.href);
                return;
              }
              desktopMenuClickHandler(toggler, menu);
            });
            toggler.addEventListener("mouseleave", (_) => desktopMenuMouseLeaveHandler(toggler, menu));
            menu.addEventListener("mouseleave", (_) => desktopMenuMouseLeaveHandler(toggler, menu));
            break;
          default: {
            console.log("openMenuType is not defined");
          }
        }
      });
      on("resize", updateDesktopMenuDropdownPosition);
    }
    if (headerMenuTogglers) {
      headerMenuTogglers.forEach((toggler) => {
        const target = document.getElementById(toggler.dataset.target);
        on("click", toggler, (event) => {
          if (openProcessing) {
            return;
          }
          let isNested = false;
          let targetMenu = document.getElementById(event.target.closest(selectors.headerMenuToggler).dataset.target);
          if (isTargetActive(targetMenu)) {
            isNested = true;
          }
          handleToggleEvent(event, target, true, 700, true, false);
          if (isNested) {
            let nextTarget;
            if (targetMenu.dataset.menuType === "deep-nested") {
              if (targetMenu.closest('[data-menu-type="deep-nested"]')) {
                drawerMenu.classList.remove(cssClasses.grandChildActive);
                nextTarget = targetMenu.closest('[data-menu-type="nested"]');
              }
            } else if (targetMenu.dataset.menuType === "nested") {
              if (targetMenu.closest('[data-menu-type="nested"]')) {
                drawerMenu.classList.remove(cssClasses.childActive);
                nextTarget = targetMenu.closest('[data-menu-type="main"]');
              }
            }
            if (nextTarget) {
              focusTarget(nextTarget);
            }
            if (!binder.isSet()) {
              binder.set();
            }
          } else {
            if (targetMenu.dataset.menuType === "deep-nested") {
              if (targetMenu.closest('[data-menu-type="deep-nested"]')) {
                drawerMenu.classList.add(cssClasses.grandChildActive);
              }
            } else if (targetMenu.dataset.menuType === "nested") {
              if (targetMenu.closest('[data-menu-type="nested"]')) {
                drawerMenu.classList.add(cssClasses.childActive);
                headerMainMenu.scrollTop = 0;
              }
            }
            setTabIndexOnTarget(targetMenu);
          }
        });
      });
    }
    on("click", document, (event) => {
      if (!event.target.closest(selectors.headerDesktopMenu) && !event.target.closest(selectors.headerDesktopMenuToggler)) {
        if (openMenuType === "hover" && event.target.matches(":not(:focus-visible)")) {
          return;
        }
        closeActiveDesktopMenus();
      }
    });
    if (hideOnScrollDown || staticHeader) {
      document.addEventListener("scroll", scrollHandler);
    }
  }
  function updateDesktopMenuDropdownPosition() {
    const headerDropdownMenu = headerDesktopMenus.find((desktopMenu) => desktopMenu.classList.contains(cssClasses.active) && desktopMenu.dataset.menuType === "dropdown-menu");
    const headerDropdownMenuNested = headerDesktopMenus.find((desktopMenu) => desktopMenu.classList.contains(cssClasses.active) && desktopMenu.dataset.menuType === "dropdown-menu-nested");
    if (!headerDropdownMenu) {
      return;
    }
    const headerDropdownToggler = headerDesktopMenuTogglers.find((toggler) => headerDropdownMenu.id === toggler.dataset.target);
    headerDropdownMenu.style.insetInlineStart = `${headerDropdownToggler.offsetLeft}px`;
    if (!headerDropdownMenuNested) {
      return;
    }
    const parentMenuPosition = headerDropdownMenu.offsetLeft + headerDropdownMenu.offsetWidth + 4;
    headerDropdownMenuNested.style.left = `${parentMenuPosition}px`;
  }
  function setEventBusListeners() {
    window.themeCore.EventBus.listen(["EscEvent:on", "Overlay:headerToggleMenuDrawer:close", "Toggle:headerToggleMenuDrawer:close"], () => {
      removeActiveClass(mainMenuToggler);
      if (getActiveElements(headerMenuList).length) {
        setTimeout(() => closeAllMenus(getActiveElements(headerMenuList)), 700);
      }
      drawerMenu.classList.remove(cssClasses.childActive);
      drawerMenu.classList.remove(cssClasses.grandChildActive);
      header.classList.remove(cssClasses.megaMenuActive);
    });
    window.themeCore.EventBus.listen("HeaderDesktopMenu:open", () => {
      closeLocalizationSelector();
    });
    window.themeCore.EventBus.listen("EscEvent:on", () => {
      closeActiveDesktopMenu();
    });
    window.themeCore.EventBus.listen("Toggle:headerToggleMenuDrawer:open", () => {
      header.classList.add(cssClasses.megaMenuActive);
      addActiveClass(mainMenuToggler);
    });
    window.themeCore.EventBus.listen(["cart:updated", "header:update-item-count"], (e) => {
      updateItemCount(e);
    });
    window.themeCore.EventBus.listen(["announcement-bar:loaded", "announcement-bar:changed"], () => {
      updateHeaderVariables();
    });
  }
  function updateHeaderVariables() {
    if (isHeaderHidden) {
      changeCssVariable(cssVariables.headerHeight, `0px`);
      headerHeight = 0;
      changeCssVariable(cssVariables.headerOffsetTop, `0px`);
      changeCssVariable(cssVariables.pageHeight, ` ${window.innerHeight}px`);
      changeCssVariable(cssVariables.headerOffsetBottom, "0px");
      return;
    }
    if (getHeaderHeight() !== headerHeight) {
      changeCssVariable(cssVariables.headerHeight, ` ${getHeaderHeight()}px`);
      changeCssVariable(cssVariables.headerHeightStatic, ` ${getHeaderHeight()}px`);
      headerHeight = getHeaderHeight();
      headerHeightStatic = headerHeight;
    }
    if (getHeaderOffsetTop() > 0) {
      changeCssVariable(cssVariables.headerOffsetTop, ` ${Math.max(getHeaderOffsetTop(), 0)}px`);
      if (getHeaderOffsetTop() > parseInt(getCssVariable(cssVariables.headerOffsetTopStatic))) {
        changeCssVariable(cssVariables.headerOffsetTopStatic, ` ${Math.max(getHeaderOffsetTop(), 0)}px`);
      }
    } else if (getCssVariable(cssVariables.headerOffsetTop) !== " 0px") {
      changeCssVariable(cssVariables.headerOffsetTop, ` ${Math.max(getHeaderOffsetTop(), 0)}px`);
    }
    changeCssVariable(cssVariables.pageHeight, ` ${window.innerHeight}px`);
    changeCssVariable(cssVariables.announcementBarHeight, ` ${getAnnouncementBarHeight()}px`);
    changeCssVariable(cssVariables.headerOffsetBottom, `${getHeaderOffsetBottom()}px`);
  }
  function updateItemCount(event) {
    if (!event.hasOwnProperty("item_count")) {
      return;
    }
    headerCartItemCountWrapper.setAttribute(attributes.itemCount, event.item_count);
    headerCartItemCount.innerHTML = event.item_count;
    if (event.item_count > 99) {
      headerCartItemCount.innerHTML = "99+";
    } else {
      headerCartItemCount.innerHTML = event.item_count;
    }
  }
  function changeCssVariable(variable, value) {
    requestAnimationFrame(() => {
      cssRoot.style.setProperty(variable, value);
    });
  }
  function getCssVariable(variable) {
    return cssRoot.style.getPropertyValue(variable);
  }
  function getHeaderHeight() {
    return header.getBoundingClientRect().height;
  }
  function getAnnouncementBarHeight() {
    if (window.Shopify.designMode) {
      announcementBar = document.querySelector(selectors.announcementBar);
    }
    if (!announcementBar) {
      return 0;
    }
    return announcementBar.getBoundingClientRect().height;
  }
  function getHeaderOffsetTop() {
    return headerInner.hasAttribute("data-static-header") ? 0 : header.getBoundingClientRect().top;
  }
  function getHeaderOffsetBottom() {
    if (headerTransparent) {
      const annBarOffset = window.scrollY <= 0 ? getAnnouncementBarHeight() : 0;
      return annBarOffset + getHeaderHeight();
    }
    const offsetBottom = header.getBoundingClientRect().bottom;
    return offsetBottom > 0 ? offsetBottom : 0;
  }
  function initDrawers() {
    headerDrawerTogglers.forEach((drawerToggler) => {
      let toggle = drawerToggler.getAttribute(attributes.drawerToggle);
      if (toggle === "searchToggleDrawer") {
        const input = document.querySelector(selectors.predictiveSearchInput);
        Toggle({
          toggleSelector: toggle,
          toggleTabIndex: true,
          elementToFocus: input,
          customCursor: false
        }).init();
        return;
      }
      Toggle({
        toggleSelector: toggle,
        toggleTabIndex: true,
        overlayPlacement: header
      }).init();
    });
  }
  function initBurgerMenu() {
    headerBurgerMenu({
      containerId: "HeaderBurgerMenu",
      overlayPlacement: header
    }).init();
  }
  function toggleScrollbarOffset(force) {
    if (force) {
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      headerInner.style.paddingRight = scrollbarWidth + "px";
    } else {
      headerInner.style.paddingRight = "";
    }
  }
  function isTargetActive(target) {
    return target.classList.contains(cssClasses.active);
  }
  function handleToggleEvent(event, target, bodyScroll, timeout, isTrapFocus, isRemoveTrapFocus) {
    event.preventDefault();
    if (timeout === void 0) {
      timeout = 200;
    }
    openProcessing = true;
    if (isTrapFocus === void 0) {
      isTrapFocus = true;
    }
    if (isRemoveTrapFocus === void 0) {
      isRemoveTrapFocus = true;
    }
    toggleActive(target, bodyScroll, timeout, isTrapFocus, isRemoveTrapFocus);
    setTimeout(() => openProcessing = false, timeout);
  }
  function toggleActive(target, bodyScroll, timeout, isTrapFocus, isRemoveTrapFocus) {
    return isTargetActive(target) ? closeToggleTarget(target, !bodyScroll, timeout, isRemoveTrapFocus) : openToggleTarget(target, bodyScroll, isTrapFocus);
  }
  function openToggleTarget(target, bodyScroll, isTrapFocus) {
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    removeHiddenClass(target);
    let togglers = [...document.querySelectorAll(`[data-target="${target.id}"]`)];
    togglers.forEach((toggler) => {
      setAriaExpanded(toggler);
      addActiveClass(toggler);
    });
    setTimeout(() => {
      addActiveClass(target);
    }, 0);
    if (bodyScroll) {
      document.body.style.overflow = "hidden";
      headerInner.style.paddingRight = scrollbarWidth + "px";
    }
    if (isTrapFocus) {
      focusTarget(target);
    }
    if (!binder.isSet()) {
      binder.set();
    }
  }
  function closeToggleTarget(target, bodyScroll, timeout, isRemoveTrapFocus) {
    if (!target || !isTargetActive(target)) {
      return;
    }
    target.classList.remove(cssClasses.active);
    let togglers = [...document.querySelectorAll(`[data-target="${target.id}"]`)];
    togglers.forEach((toggler) => {
      removeAriaExpanded(toggler);
      removeActiveClass(toggler);
    });
    setTimeout(() => addHiddenClass(target), timeout);
    if (bodyScroll) {
      document.body.style.overflow = null;
      headerInner.style.paddingRight = "0px";
    }
    if (isRemoveTrapFocus) {
      removeFocusTarget();
    }
    binder.remove();
  }
  function addActiveClass(target) {
    target.classList.add(cssClasses.active);
  }
  function removeActiveClass(target) {
    target.classList.remove(cssClasses.active);
  }
  function addHiddenClass(target) {
    target.classList.add(cssClasses.hidden);
  }
  function removeHiddenClass(target) {
    target.classList.remove(cssClasses.hidden);
  }
  function setAriaExpanded(toggler) {
    toggler.setAttribute(attributes.ariaExpanded, true);
  }
  function removeAriaExpanded(toggler) {
    toggler.setAttribute(attributes.ariaExpanded, false);
  }
  function setTabIndexOnTarget(target) {
    focusable(target).forEach((element) => {
      element.setAttribute(attributes.tabIndex, 0);
    });
  }
  function focusTarget(target, elementToFocus = null, preventScroll = false) {
    if (!target) {
      return;
    }
    previouslySelectedElement = document.activeElement;
    const focusableElements = focusable(target);
    if (focusableElements.length) {
      trapFocus(target, { elementToFocus: elementToFocus || focusableElements[0], preventScroll });
      return;
    }
    trapFocus(target);
  }
  function removeFocusTarget() {
    if (isElement(previouslySelectedElement)) {
      window.setTimeout(() => previouslySelectedElement.focus(), 0);
    }
    removeTrapFocus();
  }
  function closeAllMenus(list, isRemoveTrapFocus) {
    if (isRemoveTrapFocus === void 0) {
      isRemoveTrapFocus = true;
    }
    list.forEach((menu) => {
      closeToggleTarget(menu, true, 0, isRemoveTrapFocus);
    });
  }
  function desktopMenuClickHandler(toggler, menu) {
    toggleDesktopMenu(toggler, menu);
  }
  function desktopMenuMouseEnterHandler(toggler, menu) {
    if (timeouts.has(`${menu.id}-hover-timeout`)) {
      clearTimeout(timeouts.get(`${menu.id}-hover-timeout`));
      timeouts.delete(`${menu.id}-hover-timeout`);
    }
    const timeout = setTimeout(() => {
      toggleDesktopMenu(toggler, menu, true, false);
    }, hoverOpenDelay);
    timeouts.set(`${menu.id}-hover-timeout`, timeout);
  }
  function desktopMenuMouseLeaveHandler(toggler, menu) {
    if (timeouts.has(`${menu.id}-hover-timeout`)) {
      clearTimeout(timeouts.get(`${menu.id}-hover-timeout`));
      timeouts.delete(`${menu.id}-hover-timeout`);
    }
    const timeout = setTimeout(() => {
      var _a;
      const element = document.elementFromPoint(clientX, clientY);
      const closeNestedDropdown = menu.dataset.menuType === "dropdown-menu-nested" && !element.closest(selectors.headerDesktopMenuToggler) && ((_a = element.closest(selectors.headerDesktopMenu)) == null ? void 0 : _a.dataset.menuType) === "dropdown-menu";
      if (closeNestedDropdown) {
        const activeMenu = headerDesktopMenus.find((desktopMenu) => desktopMenu.dataset.menuType === "dropdown-menu-nested" && (desktopMenu.classList.contains(cssClasses.active) || desktopMenu.classList.contains(cssClasses.loading)));
        if (!activeMenu) {
          return;
        }
        const activeToggler = headerDesktopMenuTogglers.find((toggler2) => activeMenu.id === toggler2.dataset.target);
        closeDesktopMenuElement(activeToggler, activeMenu, false, false);
      }
      if (element.closest(selectors.headerDesktopMenuToggler) || element.closest(selectors.headerDesktopMenu)) {
        return;
      }
      closeActiveDesktopMenus(false);
    }, hoverCloseDelay);
    timeouts.set(`${menu.id}-hover-timeout`, timeout);
  }
  function toggleDesktopMenu(toggler, menu, force = null, trapFocus2 = true) {
    if (timeouts.has("toggle-timeout")) {
      clearTimeout(timeouts.get("toggle-timeout"));
      timeouts.delete("toggle-timeout");
    }
    const openMenu = force !== null ? force : !toggler.classList.contains(cssClasses.active);
    const isNestedDropdown = menu.dataset.menuType === "dropdown-menu-nested";
    let activeMenus = headerDesktopMenus.filter((desktopMenu) => menu !== desktopMenu && (desktopMenu.classList.contains(cssClasses.active) || desktopMenu.classList.contains(cssClasses.loading)));
    activeMenus.sort((a) => a.dataset.menuType === "dropdown-menu-nested" ? -1 : 1);
    let timeoutDuration = 0;
    let forceMenu = false;
    if (isNestedDropdown) {
      activeMenus = activeMenus.filter((menu2) => menu2.dataset.menuType === "dropdown-menu-nested");
    }
    if (activeMenus.length) {
      forceToggleMegaMenu = activeMenus.some((menu2) => menu2.dataset.menuType === "mega-menu") && menu.dataset.menuType === "mega-menu";
      forceCloseDropdownMenuNested = activeMenus.some((menu2) => menu2.dataset.menuType === "dropdown-menu-nested");
      forceCloseDropdownMenu = menu.dataset.menuType === "dropdown-menu" && toggler.classList.contains(cssClasses.active);
      forceMenu = forceToggleMegaMenu || forceCloseDropdownMenuNested;
      if (!forceToggleMegaMenu && !(isNestedDropdown && forceCloseDropdownMenuNested) && !forceCloseDropdownMenu) {
        timeoutDuration = 400;
      } else if (isNestedDropdown && forceCloseDropdownMenuNested) {
        timeoutDuration = 200;
      }
      activeMenus.forEach((activeMenu) => {
        const activeToggler = headerDesktopMenuTogglers.find((toggler2) => activeMenu.id === toggler2.dataset.target);
        const elementType = menu.dataset.menuType;
        switch (elementType) {
          case "mega-menu":
            closeDesktopMenuElement(activeToggler, activeMenu, forceToggleMegaMenu, trapFocus2);
            break;
          case "dropdown-menu":
            closeDesktopMenuElement(activeToggler, activeMenu, false, trapFocus2);
            break;
          case "dropdown-menu-nested":
            closeDesktopMenuElement(activeToggler, activeMenu, forceCloseDropdownMenuNested, trapFocus2);
            break;
        }
      });
    }
    const timeout = setTimeout(() => {
      openMenu ? openDesktopMenuElement(toggler, menu, forceMenu, trapFocus2) : closeDesktopMenuElement(toggler, menu, false, trapFocus2);
    }, timeoutDuration);
    timeouts.set("toggle-timeout", timeout);
  }
  function openDesktopMenuElement(toggler, menu, force = false, trapFocus2 = true) {
    const elementType = menu.dataset.menuType;
    switch (elementType) {
      case "mega-menu":
        openMegaMenu(toggler, menu, force, trapFocus2);
        break;
      case "dropdown-menu":
        openDropdownMenu(toggler, menu, false, trapFocus2);
        break;
      case "dropdown-menu-nested":
        openDropdownMenu(toggler, menu, true, trapFocus2);
        break;
    }
  }
  function closeActiveDesktopMenu() {
    if (timeouts.has("toggle-timeout")) {
      clearTimeout(timeouts.get("toggle-timeout"));
      timeouts.delete("toggle-timeout");
    }
    const activeMenu = headerDesktopMenus.find((desktopMenu) => desktopMenu.dataset.menuType === "dropdown-menu-nested" && (desktopMenu.classList.contains(cssClasses.active) || desktopMenu.classList.contains(cssClasses.loading))) || headerDesktopMenus.find((desktopMenu) => desktopMenu.classList.contains(cssClasses.active) || desktopMenu.classList.contains(cssClasses.loading));
    if (!activeMenu) {
      return;
    }
    const menuToggler = headerDesktopMenuTogglers.find((toggler) => activeMenu.id === toggler.dataset.target);
    closeDesktopMenuElement(menuToggler, activeMenu, false);
  }
  function closeActiveDesktopMenus(trapFocus2 = true) {
    if (timeouts.has("toggle-timeout")) {
      clearTimeout(timeouts.get("toggle-timeout"));
      timeouts.delete("toggle-timeout");
    }
    let activeMenus = headerDesktopMenus.filter((desktopMenu) => desktopMenu.classList.contains(cssClasses.active) || desktopMenu.classList.contains(cssClasses.loading));
    activeMenus.sort((a) => a.dataset.menuType === "dropdown-menu-nested" ? -1 : 1);
    activeMenus.forEach((activeMenu) => {
      const activeToggler = headerDesktopMenuTogglers.find((toggler) => activeMenu.id === toggler.dataset.target);
      closeDesktopMenuElement(activeToggler, activeMenu, false, trapFocus2);
    });
  }
  function closeDesktopMenuElement(toggler, menu, force = false, trapFocus2 = true) {
    const elementType = menu.dataset.menuType;
    switch (elementType) {
      case "mega-menu":
        closeMegaMenu(toggler, menu, force, trapFocus2);
        break;
      case "dropdown-menu":
        closeDropdownMenu(toggler, menu, force, false, trapFocus2);
        break;
      case "dropdown-menu-nested":
        closeDropdownMenu(toggler, menu, force, true, trapFocus2);
        break;
    }
  }
  function openMegaMenu(toggler, menu, force = false, trapFocus2 = true) {
    if (toggler.classList.contains(cssClasses.active)) {
      return;
    }
    if (timeouts.has(menu.id)) {
      const timeoutsArray = timeouts.get(menu.id);
      timeoutsArray.forEach((timeout) => clearTimeout(timeout));
      timeouts.delete(menu.id);
    }
    menu.classList.remove(cssClasses.hidden);
    // Switch the header surface before the panel is revealed so both layers
    // enter as one continuous surface instead of racing each other.
    header.classList.add(cssClasses.megaMenuActive);
    toggler.classList.add(cssClasses.loading);
    menu.classList.add(cssClasses.loading);
    menu.classList.remove(cssClasses.forceTransition);
    // Hover mega menus are an overlay: locking the page scrollbar here causes
    // the entire page below the header to reflow horizontally on every open.
    // Keep scroll locking only for click-triggered desktop menus.
    const shouldLockBody = openMenuType !== "hover";
    !force && shouldLockBody && toggleScrollbarOffset(true);
    shouldLockBody && (document.body.style.overflow = "hidden");
    removeMegaMenuBodyScroll = shouldLockBody;
    const menuScrollContainer = menu.querySelector(selectors.headerDesktopMenuScrollContainer);
    menuScrollContainer && (menuScrollContainer.scrollTop = 0);
    const menuContainer = menu.querySelector(selectors.headerDesktopMenuContainer);
    const computedMenuMaxHeight = parseFloat(window.getComputedStyle(menu).maxHeight);
    const menuMaxHeight = Number.isFinite(computedMenuMaxHeight) ? computedMenuMaxHeight : menuContainer.offsetHeight;
    const menuHeight = `${Math.min(menuMaxHeight, menuContainer.offsetHeight)}px`;
    const isHoverMenu = openMenuType === "hover";
    force && menu.classList.add(cssClasses.forceChangeTransition);
    force && menu.classList.add(cssClasses.forceTransition);
    menu.style.height = isHoverMenu ? menuHeight : force ? activeMegaMenuHeight : `0px`;
    header.style.setProperty("--menu-height", menuHeight);
    menu.offsetHeight;
    const timeoutStart = requestAnimationFrame(() => {
      force && menu.classList.remove(cssClasses.forceTransition);
      toggler.classList.add(cssClasses.active);
      menu.classList.add(cssClasses.active);
      setAriaExpanded(toggler);
      window.themeCore.EventBus.emit("HeaderDesktopMenu:open");
      activeMegaMenuHeight = menuHeight;
      menu.style.height = menuHeight;
      if (trapFocus2) {
        focusTarget(menu, null, true);
        if (!binder.isSet()) {
          binder.set();
        }
      }
    }, 0);
    timeouts.set(menu.id, [timeoutStart]);
    const timeoutEnd = setTimeout(() => {
      menu.style.height = ``;
      toggler.classList.remove(cssClasses.loading);
      menu.classList.remove(cssClasses.loading);
      menu.classList.remove(cssClasses.forceChangeTransition);
    }, isHoverMenu ? hoverMegaMenuTransitionDuration : 400);
    timeouts.set(menu.id, [...timeouts.get(menu.id), timeoutEnd]);
  }
  function closeMegaMenu(toggler, menu, force = false, trapFocus2 = true) {
    if (!toggler.classList.contains(cssClasses.active)) {
      return;
    }
    if (timeouts.has(menu.id)) {
      const timeoutsArray = timeouts.get(menu.id);
      timeoutsArray.forEach((timeout) => clearTimeout(timeout));
      timeouts.delete(menu.id);
    }
    const isHoverMenu = openMenuType === "hover";
    const timeoutDuration = force ? 0 : isHoverMenu ? hoverMegaMenuTransitionDuration : 400;
    const menuContainer = menu.querySelector(selectors.headerDesktopMenuContainer);
    const computedMenuMaxHeight = parseFloat(window.getComputedStyle(menu).maxHeight);
    const menuMaxHeight = Number.isFinite(computedMenuMaxHeight) ? computedMenuMaxHeight : menuContainer.offsetHeight;
    menu.style.height = `${Math.min(menuMaxHeight, menuContainer.offsetHeight)}px`;
    toggler.classList.add(cssClasses.loading);
    toggler.classList.remove(cssClasses.active);
    menu.classList.add(cssClasses.loading);
    menu.classList.remove(cssClasses.active);
    menu.classList.remove(cssClasses.forceChangeTransition);
    force && menu.classList.add(cssClasses.forceTransition);
    removeAriaExpanded(toggler);
    window.themeCore.EventBus.emit("HeaderDesktopMenu:close");
    !force && header.style.setProperty("--menu-height", `0px`);
    menuContainer.offsetHeight;
    const timeoutStart = setTimeout(() => {
      if (!isHoverMenu) {
        menu.style.height = `0px`;
      }
      const isGlobalOverlayActive = document.querySelector(selectors.globalOverlay);
      if (trapFocus2) {
        if (!isGlobalOverlayActive) {
          removeFocusTarget();
          binder.remove();
        }
      } else {
        toggler.blur();
      }
    }, 0);
    timeouts.set(menu.id, [timeoutStart]);
    const timeoutEnd = setTimeout(() => {
      if (isHoverMenu) {
        menu.style.height = `0px`;
      }
      toggler.classList.remove(cssClasses.loading);
      menu.classList.remove(cssClasses.loading);
      menu.classList.add(cssClasses.hidden);
      menu.classList.remove(cssClasses.forceTransition);
      if (force) {
        header.classList.remove(cssClasses.megaMenuActive);
      } else {
        header.classList.remove(cssClasses.megaMenuActive);
        if (removeMegaMenuBodyScroll) {
          document.body.style.overflow = null;
          toggleScrollbarOffset(false);
        }
      }
    }, timeoutDuration);
    timeouts.set(menu.id, [...timeouts.get(menu.id), timeoutEnd]);
  }
  function openDropdownMenu(toggler, menu, nested = false, trapFocus2 = true) {
    if (toggler.classList.contains(cssClasses.active)) {
      return;
    }
    if (timeouts.has(menu.id)) {
      const timeoutsArray = timeouts.get(menu.id);
      timeoutsArray.forEach((timeout) => clearTimeout(timeout));
      timeouts.delete(menu.id);
    }
    menu.classList.remove(cssClasses.hidden);
    menu.classList.remove(cssClasses.forceTransition);
    toggler.classList.add(cssClasses.loading);
    menu.classList.add(cssClasses.loading);
    const menuScrollContainer = menu.querySelector(selectors.headerDesktopMenuScrollContainer);
    menuScrollContainer && (menuScrollContainer.scrollTop = 0);
    const menuContainer = menu.querySelector(selectors.headerDesktopMenuContainer);
    if (nested) {
      const menuMaxWidth = parseFloat(window.getComputedStyle(menuContainer).maxWidth);
      const parentMenu = toggler.closest(selectors.headerDesktopMenu);
      const parentMenuWidth = Math.min(menuMaxWidth, menuContainer.offsetWidth);
      const parentMenuPosition = parentMenu.offsetLeft + parentMenu.offsetWidth + 4;
      menu.style.left = `${parentMenuPosition}px`;
      menu.style.width = `${parentMenuWidth}px`;
    } else {
      const togglerPosition = toggler.offsetLeft;
      menu.style.insetInlineStart = `${togglerPosition}px`;
    }
    const timeoutStart = setTimeout(() => {
      toggler.classList.add(cssClasses.active);
      menu.classList.add(cssClasses.active);
      setAriaExpanded(toggler);
      header.style.setProperty("--menu-height", `0px`);
      window.themeCore.EventBus.emit("HeaderDesktopMenu:open");
      if (trapFocus2) {
        focusTarget(menu, menu, true);
        if (!binder.isSet()) {
          binder.set();
        }
      }
    }, 0);
    timeouts.set(menu.id, [timeoutStart]);
    const timeoutEnd = setTimeout(() => {
      toggler.classList.remove(cssClasses.loading);
      menu.classList.remove(cssClasses.loading);
    }, 400);
    timeouts.set(menu.id, [...timeouts.get(menu.id), timeoutEnd]);
  }
  function closeDropdownMenu(toggler, menu, force = false, nested = false, trapFocus2 = true) {
    if (!toggler.classList.contains(cssClasses.active)) {
      return;
    }
    if (timeouts.has(menu.id)) {
      const timeoutsArray = timeouts.get(menu.id);
      timeoutsArray.forEach((timeout) => clearTimeout(timeout));
      timeouts.delete(menu.id);
    }
    const timeoutDuration = force ? 0 : 400;
    const menuContainer = menu.querySelector(selectors.headerDesktopMenuContainer);
    if (nested) {
      const menuMaxWidth = parseFloat(window.getComputedStyle(menuContainer).maxWidth);
      menu.style.width = `${Math.min(menuMaxWidth, menuContainer.offsetWidth)}px`;
    } else {
      const menuMaxHeight = parseFloat(window.getComputedStyle(menuContainer).maxHeight);
      menu.style.height = `${Math.min(menuMaxHeight, menuContainer.offsetHeight)}px`;
    }
    toggler.classList.add(cssClasses.loading);
    toggler.classList.remove(cssClasses.active);
    menu.classList.add(cssClasses.loading);
    menu.classList.remove(cssClasses.active);
    removeAriaExpanded(toggler);
    force && menu.classList.add(cssClasses.forceTransition);
    header.style.setProperty("--menu-height", `0px`);
    window.themeCore.EventBus.emit("HeaderDesktopMenu:close");
    menuContainer.offsetHeight;
    const timeoutStart = setTimeout(() => {
      const isGlobalOverlayActive = document.querySelector(selectors.globalOverlay);
      if (trapFocus2) {
        if (isGlobalOverlayActive) {
          return;
        }
        if (nested) {
          const parentMenu = toggler.closest(selectors.headerDesktopMenu);
          focusTarget(parentMenu, toggler, true);
        } else {
          removeFocusTarget();
          binder.remove();
        }
      } else {
        toggler.blur();
      }
    }, 0);
    timeouts.set(menu.id, [timeoutStart]);
    const timeoutEnd = setTimeout(() => {
      toggler.classList.remove(cssClasses.loading);
      menu.classList.remove(cssClasses.loading);
      menu.classList.add(cssClasses.hidden);
      force && menu.classList.remove(cssClasses.forceTransition);
      if (nested && !binder.isSet()) {
        binder.set();
      }
    }, timeoutDuration);
    timeouts.set(menu.id, [...timeouts.get(menu.id), timeoutEnd]);
  }
  function getActiveElements(list) {
    return list.filter((item) => isTargetActive(item));
  }
  function headerTopPositionHandler() {
    let condition = window.scrollY <= 0;
    if (condition && !header.classList.contains("header-section--top-position")) {
      header.classList.add("header-section--top-position");
    } else if (!condition && header.classList.contains("header-section--top-position")) {
      header.classList.remove("header-section--top-position");
    }
  }
  function scrollHandler() {
    let currentScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    let condition = staticHeader ? currentScrollPosition > 0 : currentScrollPosition > 0 && lastScrollPosition <= currentScrollPosition;
    if (condition && getComputedStyle(document.body).overflow !== "hidden" && Math.max(header.getBoundingClientRect().y, 0) + getAnnouncementBarHeight() < currentScrollPosition) {
      closeLocalizationSelector();
      closeActiveDesktopMenus(true);
      header.classList.add(cssClasses.collapsed);
      isHeaderHidden = true;
    } else {
      header.classList.remove(cssClasses.collapsed);
      isHeaderHidden = false;
    }
    lastScrollPosition = currentScrollPosition;
  }
  function closeLocalizationSelector() {
    const localizationForms = [...document.querySelectorAll(selectors.localizationForm)];
    localizationForms.forEach((form) => {
      const links = form.querySelectorAll(selectors.localizationLink);
      const button = form.querySelector(selectors.localizationButton);
      const panel = form.querySelector(selectors.localizationPanel);
      panel.setAttribute(attributes.hidden, "true");
      button.setAttribute(attributes.ariaExpanded, "false");
      links.forEach((link) => link.setAttribute("tabindex", -1));
    });
  }
  function navigateToLink(href) {
    if (href) {
      window.location.href = href;
    }
  }
  return Object.freeze({
    init,
    getHeaderHeight: () => headerHeight,
    getHeaderHeightStatic: () => headerHeightStatic
  });
};
const action = () => {
  window.themeCore.Header = window.themeCore.Header || Header();
  window.themeCore.utils.register(window.themeCore.Header, "header");
};
if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener("theme:all:loaded", action, { once: true });
}
